module.exports = __webpack_public_path__ + "img/EAST_YEARBOOK-26-min.48490ca8.jpg";